import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import BSWheatPastaProduct from 'models/BSWheatPastaProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState } from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { isNotNumericDecimal } from 'context/Utilities'

const WheatPastaPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, PastaShape, Size } = current
      setPackaging({
        category,
        subCategory,
        PastaShape: PastaShape ?? '',
        Size,
      })
    } else if (!updating) {
      setCurrent(BSWheatPastaProduct)
      setPackaging(packagingInitialState)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <p>
          <strong>Pasta Shape {asterisk}</strong>
        </p>
        <Controller
          as={Input}
          name="PastaShape"
          control={methods.control}
          rules={{
            required: {
              value: true,
              message: '⚠ Please enter a pasta shape.',
            },
            maxLength: {
              value: 25,
              message: '⚠ Pasta Shape exceeds 25 characters.',
            },
          }}
          onKeyDown={e => {
            if (
              ![
                'Backspace',
                'Delete',
                'Tab',
                'ArrowLeft',
                'ArrowRight',
                ' ',
              ].includes(e.key) &&
              (e.key.toLowerCase() < 'a' || e.key.toLowerCase() > 'z')
            ) {
              e.preventDefault()
            }
          }}
          onChange={([event]) => {
            onChange(event)
            return event
          }}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="PastaShape"
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="Size"
            defaultValue={packaging.Size}
            placeholder={'12 - 48 ounces'}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            control={methods.control}
            rules={{
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
              min: {
                value: 12,
                message: '⚠ Size is below the required 12 ounce minimum.',
              },
              max: {
                value: 48,
                message: '⚠ Size exceeds the 48 ounces allowed.',
              },
              required: {
                value: true,
                message: '⚠ Please enter product size.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default WheatPastaPackage
